import React from 'react';
import { Alert, Button, CircularProgress } from '@mui/material';
import { Redirect } from 'react-router-dom';
import { useChatAccess } from '../../hooks/chat/useChatAccess';

export function ChatAccess({ children }: { children: React.ReactNode }) {
  const { canAccess, loading, error, retry } = useChatAccess();
  if (loading) return <CircularProgress aria-label="Checking chat access" />;
  if (error) {
    return (
      <Alert
        severity="error"
        action={
          <Button sx={{ float: 'none' }} onClick={() => retry()}>
            Retry
          </Button>
        }
      >
        Unable to check chat access. Please try again.
      </Alert>
    );
  }
  if (!canAccess) return <Redirect to="/" />;
  return <>{children}</>;
}
